// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { getInventoryProducts } from "@redotech/redo-product-api/get-inventory-products";
import { createBarcodeLabelTemplate } from "./schema/barcode-label-template/create-barcode-label-template";
import { deleteBarcodeLabelTemplate } from "./schema/barcode-label-template/delete-barcode-label-template";
import { getBarcodeLabelTemplate } from "./schema/barcode-label-template/get-barcode-label-template";
import { getBarcodeLabelTemplates } from "./schema/barcode-label-template/get-barcode-label-templates";
import { renderBarcodeLabelTemplate } from "./schema/barcode-label-template/render-barcode-label-template";
import { saveBarcodeLabelTemplate } from "./schema/barcode-label-template/save-barcode-label-template";
import { setManagedReturnsBarcodeLabelTemplateEnabled } from "./schema/barcode-label-template/set-managed-returns-barcode-label-template-enabled";
import { exportAdjustmentReport } from "./schema/export-adjustment-report";
import { exportCogsReport } from "./schema/export-cogs-report";
import { exportInventoryLevels } from "./schema/export-inventory-levels";
import { generateBarcodeLabel } from "./schema/generate-barcode-label";
import { generateInventoryLevelReport } from "./schema/generate-inventory-level-report";
import {
  getAdjustmentReport,
  getAdjustmentReportColumns,
} from "./schema/get-adjustment-report";
import { getAdjustmentReportCount } from "./schema/get-adjustment-report-count";
import { getCatalogTags } from "./schema/get-catalog-tags";
import { getCatalogVendors } from "./schema/get-catalog-vendors";
import {
  getCogsReportRows,
  getCogsReportSummary,
} from "./schema/get-cogs-report";
import { getConsignmentCatalog } from "./schema/get-consignment-catalog";
import { getCostLedgerStatus } from "./schema/get-cost-ledger-status";
import { getForecastingVariants } from "./schema/get-forecasting-variants";
import { getImsStatus } from "./schema/get-ims-status";
import { getInventoryMerchants } from "./schema/get-inventory-merchants";
import { getInventoryProductsCount } from "./schema/get-inventory-products-count";
import {
  getInventoryValuationRows,
  getInventoryValuationSummary,
} from "./schema/get-inventory-valuation";
import { getLocations } from "./schema/get-locations";
import { getLocationsWithUnfulfilledOrders } from "./schema/get-locations-with-unfulfilled-orders";
import { getProductCatalogCount } from "./schema/get-product-catalog-count";
import { getProductInventory } from "./schema/get-product-inventory";
import { getProductInventoryLevels } from "./schema/get-product-inventory-levels";
import { getProductsActiveLocations } from "./schema/get-products-active-locations";
import { getShopifyPublications } from "./schema/get-shopify-publications";
import { getSkuOnHandHistory } from "./schema/get-sku-on-hand-history";
import { getSkuSalesForecast } from "./schema/get-sku-sales-forecast";
import { getSkuSalesForecastBatch } from "./schema/get-sku-sales-forecast-batch";
import { getSuggestedProductsForLiquidation } from "./schema/get-suggested-products-for-liquidation";
import { getVariantInventoryByLocation } from "./schema/get-variant-inventory-by-location";
import { getWarehouses } from "./schema/get-warehouses";
import { listCommittedOrders } from "./schema/list-committed-orders";
import { generateProductBarcode } from "./schema/product-catalog/generate-product-barcode";
import { searchProducts } from "./schema/search-products";
import { searchProductsByBarcode } from "./schema/search-products-by-barcode";
import { setProductLocations } from "./schema/set-product-locations";
import { upsertForecastAdjustmentsForPeriod } from "./schema/upsert-forecast-adjustments-for-period";
import { updateInventoryViewOrdering } from "./schema/views/update-inventory-view-ordering";

export const groupF = {
  createBarcodeLabelTemplate,
  deleteBarcodeLabelTemplate,
  getBarcodeLabelTemplate,
  getBarcodeLabelTemplates,
  renderBarcodeLabelTemplate,
  saveBarcodeLabelTemplate,
  setManagedReturnsBarcodeLabelTemplateEnabled,
  exportAdjustmentReport,
  exportCogsReport,
  exportInventoryLevels,
  getAdjustmentReport,
  getAdjustmentReportColumns,
  getAdjustmentReportCount,
  updateInventoryViewOrdering,
  setProductLocations,
  generateBarcodeLabel,
  generateProductBarcode,
  generateInventoryLevelReport,
  getCatalogTags,
  getCostLedgerStatus,
  getCogsReportRows,
  getCogsReportSummary,
  getCatalogVendors,
  getConsignmentCatalog,
  getForecastingVariants,
  getImsStatus,
  getInventoryMerchants,
  getInventoryProducts,
  getInventoryProductsCount,
  getInventoryValuationRows,
  getInventoryValuationSummary,
  getLocations,
  getLocationsWithUnfulfilledOrders,
  listCommittedOrders,
  getProductsActiveLocations,
  getProductCatalogCount,
  getProductInventory,
  getProductInventoryLevels,
  getShopifyPublications,
  getSkuOnHandHistory,
  getSkuSalesForecast,
  getSkuSalesForecastBatch,
  getSuggestedProductsForLiquidation,
  getVariantInventoryByLocation,
  getWarehouses,
  searchProducts,
  searchProductsByBarcode,
  upsertForecastAdjustmentsForPeriod,
};
